import { TDependantFieldsFragment, TEmployeeFieldsFragment, TEventTypes, TGiftFieldsFragment, TListEmployeeAndDependatsGiftsQuery, TRecipientFieldsFragment } from '../../generated/graphql';

export type TGift = Exclude<TListEmployeeAndDependatsGiftsQuery['listEmployeeAndDependatsGifts']['items'][number], null | undefined>;

const isEmployeeRecipient = (recipient: TRecipientFieldsFragment): recipient is TEmployeeFieldsFragment => {
  return (recipient as TDependantFieldsFragment).type == null;
};

export const getGiftRecipientType = (gift: TGiftFieldsFragment) => {
  if (gift.recipient == null) return undefined;

  if (isEmployeeRecipient(gift.recipient)) return 'Employee';
  else
    switch (gift.recipient.type) {
      case 'child':
        return 'Child';
      case 'significantOther':
        return 'Signficant Other';
      case 'pet':
        return gift.recipient.petType || 'Pet';
    }
};

type TGiftWithEvent = {
  event?: {
    type: TEventTypes;
    customType?: string | null;
  } | null;
};

export const getGiftEventType = (gift: TGiftWithEvent) => {
  switch (gift.event?.type) {
    case TEventTypes.Birthday:
      return 'Birthday';
    case TEventTypes.WorkAnniversary:
      return 'Work Anniversary';
    case TEventTypes.NewHire:
      return 'New Hire';
    case TEventTypes.BabyGift:
      return 'Baby Gift';
    case TEventTypes.Bereavement:
      return 'Bereavement';
    case TEventTypes.Wedding:
      return 'Wedding/Engagement';
    case TEventTypes.ReplacementWorkAnniversary:
      return 'Replacement Work Anniversary';
    case TEventTypes.ReplacementEmployeeBirthday:
      return 'Replacement Employee Birthday';
    case TEventTypes.CarePackage:
      return 'Care Package';
    case TEventTypes.CustomBricks:
      return 'Custom Bricks';
    case TEventTypes.Other:
      return gift.event?.customType;
  }
};
